import {
  DashboardIcon,
  Reports,
  Profile,
  Resources,
  Solutions,
  MyTeam,
  Team,
} from './assets.js';

export const EmployeeRoutes = [
  {
    icon: DashboardIcon,
    title: 'Dashboard',
    active: '',
    to: '/',
  },
  {
    icon: Reports,
    title: 'Reports',
    active: 'reports',
    to: '/reports',
    hide: true,
  },
  {
    icon: Solutions,
    title: 'Action Steps',
    active: 'action-steps',
    to: '/action-steps',
  },
  {
    icon: Resources,
    title: 'Resources',
    active: 'resources',
    to: '/resources',
  },
  {
    divider: true,
  },
  // {
  //   icon: Profile,
  //   title: 'Profile',
  //   active: 'profile',
  //   to: '/profile',
  // },
  // {
  //   icon: Team,
  //   title: 'Team',
  //   active: 'team',
  //   to: '/team',
  // },
  // {
  //   icon: Share,
  //   title: 'Share',
  //   active: 'share',
  //   to: '/dashboard',
  //   extraClass: 'share',
  // },
];

export const ManagerRoutes = [
  {
    icon: DashboardIcon,
    title: 'Dashboard',
    active: '',
    to: '/',
  },
  {
    icon: MyTeam,
    title: 'Invitations',
    active: 'manager-invite',
    to: '/manager-invite',
  },
  {
    icon: Reports,
    title: 'Reports',
    active: 'reports',
    to: '/reports',
    hide: true,
  },
  {
    icon: Solutions,
    title: 'Action Steps',
    active: 'action-steps',
    to: '/action-steps',
  },
  {
    icon: Resources,
    title: 'Resources',
    active: 'resources',
    to: '/resources',
  },
  {
    divider: true,
  },
  {
    icon: Profile,
    title: 'Profile',
    active: 'profile',
    to: '/profile',
  },
  {
    icon: Team,
    title: 'Team',
    active: 'team',
    to: '/team',
  },
  // {
  //   icon: Share,
  //   title: 'Share',
  //   active: 'share',
  //   to: '/dashboard',
  //   extraClass: 'share',
  // },
];
